<template>
  <div class="document-tab documents">
    <CommonDialog
      v-if="is_visible.document_dialog"
      :is_visible="is_visible.document_dialog"
      title="Удалить документ"
      text="Вы действительно хотите удалить этот документ?"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="removeDocument(deletedDoc)"
      @cancel-callback="closeDialog('document_dialog', null, 'deletedDoc')"
    >
    </CommonDialog>
    <Alert
      v-if="!documents.length"
      text="Нет прикрепленных документов"
      class="document-tab__alert"
    />
    <form id="upload-doc" enctype="multipart/form-data">
      <Upload
        name="filename_file"
        :file="filename_file"
        :multiple="true"
        :show-file-list="false"
        uploadText="Перетащите сюда любой документ"
        class="document-tab__upload"
        @upload-file="uploadDocument"
      ></Upload>
    </form>

    <SubpanelTable
      v-if="documents.length"
      :tableColumns="tableColumns"
      :tableData="documents"
      :allowDelete="true"
      @downloadFile="downloadFile"
      @handleDelete="showDocumentDialog"
      :class="[
        'document-tab__list',
        isVacancy ? 'documents-vacancy' : '',
        isRespond ? 'documents-respond' : '',
        isCandidate ? 'documents-candidate' : ''
      ]"
    />
  </div>
</template>

<script>
import { getController, postController } from '@/controllers/request.js';
import { mixin } from '@/utils/mixins';
import Alert from 'Elements/Alert/Alert';
import Upload from 'Elements/Upload/Upload';
import CommonDialog from 'Elements/Dialog/CommonDialog';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import { MODULE, ACTION } from '@/utils/constants';

export default {
  mixins: [mixin],
  props: {
    userId: {
      type: String
    },
    module: {
      type: String,
      default: MODULE.VACANCY_MODULE
    },
    id: {
      type: String
    },

    metadata: [Array, Object]
  },
  data() {
    return {
      documents: [],
      deletedDoc: null,
      filename_file: [],
      tableSql: '',
      tableColumns: {
        filename: {
          lbl: {
            value: 'Файл'
          }
        },
        date_entered: {
          lbl: {
            value: 'Дата и время загрузки'
          }
        },
        created_by_name: {
          lbl: {
            value: 'Автор'
          }
        }
      },
      is_visible: {
        document_dialog: false
      }
    };
  },
  created() {
    if (this.metadata?.List?.length) {
      this.documents = this.metadata.List;
    }

    this.tableSql =
      this.module == MODULE.CANDIDATES_MODULE
        ? 'hrpac_candidates_documents_1'
        : this.module == MODULE.CANDIDATE_RESPONDS
        ? 'hrpac_candidate_responds_documents_link'
        : 'hrpac_vacancy_documents_1';
  },
  computed: {
    isVacancy() {
      return this.module == MODULE.VACANCY_MODULE;
    },
    isRespond() {
      return this.module == MODULE.CANDIDATE_RESPONDS;
    },
    isCandidate() {
      return this.module == MODULE.CANDIDATES_MODULE;
    }
  },
  methods: {
    downloadFile(id) {
      let url =
        '/index.php?entryPoint=download_spa' + `&id=${id}` + `&type=Documents`;
      getController({
        url
      })
        .then(resp => {
          let blob = new Blob([this.s2ab(atob(resp.data.fileData))], {
            type: resp.data.fileType
          });
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');

          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = resp.data.fileName;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);

          this.deletedDoc = null;
        })
        .catch(() =>
          this.showFullNotification({
            title: 'Ошибка загрузки',
            showClose: true,
            type: 'error',
            customClass: 'vacancy-success__toast',
            position: 'top-left',
            duration: 10000,
            offset: 100
          })
        );
    },
    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    updateDocumentsList() {
      this.$emit('reloadTab');
    },
    showDocumentDialog(doc) {
      this.deletedDoc = doc;
      this.$set(this.is_visible, 'document_dialog', true);
    },
    removeDocument(doc) {
      const iscreated_by_name = doc && (this.userId === doc.created_by || true);

      this.$set(this.is_visible, 'document_dialog', false);

      if (iscreated_by_name) {
        getController({
          params: {
            module: this.module,
            action: ACTION.DELETE_RELATIONSHIP,
            record: this.id,
            return_action: ACTION.DELETE_RELATIONSHIP,
            return_module: this.module,
            return_id: this.id,
            linked_field: this.tableSql,
            linked_id: doc.id && doc.id.value ? doc.id.value : doc.id,
            refresh_page: 0,
            inline: 1,
            ajaxSubpanel: true
          }
        })
          .then(() => {
            this.deletedDoc = null;

            this.updateDocumentsList();
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при удалении документа',
              'document remove'
            )
          );
      }
    },
    updateFormData(newId, formData) {
      formData.set('module', MODULE.DOCUMENTS);
      formData.set('action', ACTION.SAVE);
      formData.set('relate_to', this.tableSql);
      formData.set('relate_id', newId);
      formData.set('parent_type', this.module);
      formData.set('parent_id', newId);
      formData.set('revision', 1);
      formData.set('jsqon_return', 1);
      return formData;
    },
    uploadDocument(file) {
      const form = document.getElementById('upload-doc');
      let formData = new FormData(form);
      formData = this.updateFormData(this.id, formData);

      this.documents.push({ file: file.name });

      if (file) {
        const { raw: blob, name } = file;
        formData.set('filename_file', blob, name);

        const params = {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        };

        postController({ options: formData, params })
          .then(() => {
            this.filename_file = [];
          })
          .catch(err =>
            console.error(
              err,
              'Возникла ошибка при загрузке документа',
              'upload file'
            )
          )
          .finally(() => {
            this.updateDocumentsList();
          });
      }
    }
  },
  components: {
    Upload,
    Alert,
    SubpanelTable,
    CommonDialog
  }
};
</script>

<style lang="scss" scoped>
.documents {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px;
  gap: 16px;

  &-vacancy {
    height: calc(100vh - 335px) !important;
  }

  &-respond,
  &-candidate {
    height: calc(100vh - 315px) !important;
  }

  .document-tab__alert {
    margin-bottom: 26px;
  }
}
</style>
